import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './CheckboxSwitch.css';

function CheckboxSwitch({ name, checked, onChange, value, ariaLabel = "", disabled }) {
  
  return (
    <>
      <label className={s.switch}>
        <input
          name={name}
          disabled={disabled}
          type="checkbox"
          checked={checked} 
          onChange={onChange}
          aria-label={ariaLabel}
          value={value}
        />
        <span
          className={`${disabled ? s.sliderDisabled : s.slider} ${s.round}`}
          tabIndex={0}
        />
      </label>
    </>
  );
}

export default withStyles(s)(CheckboxSwitch);
